import statesList from '../../../common/states.json';

export const isEventNational = ({ legislatureType }) =>
  legislatureType && legislatureType.toLowerCase() === 'national';

export const getStateAbbr = ({ location }) =>
  (location || {}).stateAbbreviation;

export const getStateName = ({location, legislatureType}) => {
  const stateCode = getStateAbbr({location});
  if (legislatureType && legislatureType.toLowerCase() === 'national') {
    return 'National';
  }
  let stateName = '';
  Object.keys(statesList).forEach(key => 
    stateName = statesList[key].id === stateCode ? statesList[key].name : stateName);
  return stateName || '';
}

export const getStateNameFromStateCode = stateCode => {
  if (stateCode.toLowerCase() === 'dc') {
    return 'National';
  }
  let stateName = '';
  Object.keys(statesList).forEach(key => 
    stateName = statesList[key].id === stateCode ? statesList[key].name : stateName);
  return stateName || '';
}

export const getLocationText = ({location, isRemote}) => {
  const {city, stateAbbreviation} = location || {};

  if (!isRemote && city && stateAbbreviation) {
    return `${city}, ${stateAbbreviation}`;
  }
  return '';
}



// WEBPACK FOOTER //
// ./src/App/events/utils/index.js